/// <amd-module name="VSSUI/IdentityCard" />
export { IdentityCard } from "./Components/IdentityCard/IdentityCard";
